import React from "react";
import {Col, FormGroup, Input, Label, Row} from "reactstrap";

// component
import {LangController} from "../../../components/tabs/langController";

// labels
import {FL_DESCRIPTION, FL_IMAGE, FL_TITLE} from "../../../components/i18n/formLabels";
import {PH_DESCRIPTION, PH_IMAGE, PH_TITLE} from "../../../components/i18n/placeHolders";
import MarkdownInput from "../../../components/inputs/MarkdownInput";

const WidgetLang = props => {
    const setDataDefault = (activeLangs, setLangChilds) => {
        const items = activeLangs.map( lang => ({
            id: '',
            lang: { id:lang?.id, name:lang?.name, showOrder: lang?.showOrder },
            title: '',
            description: '',
            mainImage: '',
        }) )

        setLangChilds(items);
    }

    const getFormulary = (child, index, disableInputs, onInputChange) => <>
        <Row>
            <Col md={"8"}>
                <FormGroup>
                    <Label>{FL_TITLE}</Label>
                    <Input
                        type="text"
                        name="title"
                        placeholder={PH_TITLE}
                        value= { child.title }
                        onChange={({target:{name, value}}) => onInputChange(name,value,child?.lang)}
                        disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md={"4"}>
                <FormGroup>
                    <Label>{FL_IMAGE}</Label>
                    <Input
                        type="text"
                        name="mainImage"
                        placeholder={PH_IMAGE}
                        value= { child.mainImage }
                        onChange={({target:{name, value}}) => onInputChange(name,value,child?.lang)}
                        disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md={"12"}>
                <FormGroup>
                    {/*<Label>{FL_DESCRIPTION}</Label>*/}
                    {/*<Input*/}
                    {/*    type="textarea"*/}
                    {/*    rows="10"*/}
                    {/*    name="description"*/}
                    {/*    placeholder={PH_DESCRIPTION}*/}
                    {/*    value= { child.description }*/}
                    {/*    onChange={({target:{name, value}}) => onInputChange(name,value,child?.lang)}*/}
                    {/*    disabled={disableInputs}*/}
                    {/*/>*/}
                    <MarkdownInput
                        label={FL_DESCRIPTION}
                        placeholder={PH_DESCRIPTION}
                        type="textarea"
                        name="description"
                        rows={'10'}
                        onChange={onInputChange}
                        disabled={disableInputs}
                        child={child}
                    />
                </FormGroup>
            </Col>
        </Row>
    </>

    return <LangController
        markdown={true}
        langs={props.langs}
        setLangs={props.setLangs}
        getFormulary={getFormulary}
        setDataDefault={setDataDefault}
        translatableLangs={props.translatableLangs}
    />
}

export default WidgetLang